import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';

@invoke
export default class BannerComponent {
  static Instance: BannerComponent;
  private static readonly PER_PAGE = 1;

  constructor() {
    BannerComponent.Instance = this;
  }

  onInit() {
    BannerComponent.refreshBannerComponent();
  }

  static refreshBannerComponent = (): void => {
    const selector = '[data-container="banner-full-slider"]';
    document.querySelectorAll(selector).forEach((list) => {
      if (!(list instanceof HTMLElement) || list.classList.contains('splide')) return;

      BannerComponent.removeEmptySlidesFromDOM(list);
      const numberOfSlides = BannerComponent.getNumberOfSlides(list);
      if (numberOfSlides === 0) {
        list.remove();
        return;
      }

      if (numberOfSlides === BannerComponent.PER_PAGE) {
        return;
      }

      BannerComponent.initializeSlider(list);
    });
  };

  // We have to generate 3 empty slides before calling Kevel in the cf worker
  // Therefore we need to remove placeholder slides if no ads are returned from Kevel
  private static removeEmptySlidesFromDOM = (list: HTMLElement): void => {
    const slidesArray = Array.from(list.querySelectorAll('.splide__slide'));
    for (const slide of slidesArray) {
      const img = slide.querySelector('img');
      if (!img || img.classList?.contains('empty')) {
        slide.remove();
      }
    }
  };

  private static getNumberOfSlides = (list: HTMLElement): number => {
    return list.querySelectorAll('.splide__slide').length;
  };

  private static initializeSlider(list: HTMLElement): void {
    list.classList.add('splide');

    const slider = new Splide(list as HTMLElement, {
      type: 'loop',
      perPage: BannerComponent.PER_PAGE,
      autoplay: true,
      interval: 7000,
      arrows: true, // Removed in the mobile view with CSS
      snap: true,
      pagination: true,
      mediaQuery: 'min',
    });

    slider.mount();
  }
}
